import React from 'react';

import { getStatusType } from 'newComponents/NewNotifications/NotificationItem/util';
import { Container } from './styles';

type StatusRefuelProps = {
  statusCode: string;
  newOrigin?: boolean;
};

const StatusRefuel: React.FC<StatusRefuelProps> = ({
  statusCode,
  newOrigin,
}) => {
  return (
    <Container statusCode={statusCode} newOrigin={newOrigin}>
      <span>{getStatusType(statusCode, 'refuel', true)}</span>
    </Container>
  );
};

StatusRefuel.defaultProps = {
  newOrigin: false,
};

export default StatusRefuel;
